import React, { useEffect, useState } from "react";
import AsyncSelect from "react-select/async";
import { getApi } from "../../../services/api/globalApi";

const { forwardRef, useImperativeHandle } = React;

const UsersSelect = forwardRef(({ oldUsers, onChange, label }, ref) => {
  const [selectedUsers, setSelectedUsers] = useState([]);

  useImperativeHandle(ref, () => ({
    afterSubmit() {
      setSelectedUsers([]);
    },
  }));

  const loadUsers = async (inputValue) => {
    try {
      const response = await getApi({ 
        path: "admin/users",
        params: { 
          limit: 20,
          searchText: inputValue || ""
        }
      });
      const userData = response?.data?.result?.data || [];
      
      return userData.map((user) => ({
        value: user._id,
        label: user.name ? `${user.mobile || user.phoneNumber} - ${user.name}` : (user.mobile || user.phoneNumber),
      }));
    } catch (error) {
      console.error("Error fetching users:", error);
      return [];
    }
  };

  useEffect(() => {
    const loadOldUsers = async () => {
      if (oldUsers?.length > 0) {
        try {
          const userPromises = oldUsers.map(async (userId) => {
            const response = await getApi({ 
              path: `admin/users/${userId}`
            });
            const user = response?.data?.result;
            return user ? {
              value: user._id,
              label: user.name ? `${user.mobile || user.phoneNumber} - ${user.name}` : (user.mobile || user.phoneNumber),
            } : null;
          });
          
          const loadedUsers = await Promise.all(userPromises);
          setSelectedUsers(loadedUsers.filter(Boolean));
        } catch (error) {
          console.error("Error loading old users:", error);
        }
      }
    };
    
    loadOldUsers();
  }, [oldUsers]);

  function handleUsers(data) {
    setSelectedUsers(data);
    const newData = data.map((item) => item.value);
    onChange(newData || []);
  }

  return (
    <div>
      <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
        {label || "انتخاب کاربران"}
      </label>
      <AsyncSelect
        cacheOptions
        defaultOptions
        loadOptions={loadUsers}
        placeholder="جستجو و انتخاب کاربران"
        value={selectedUsers}
        onChange={handleUsers}
        isSearchable={true}
        isMulti
        noOptionsMessage={() => "کاربری یافت نشد"}
        loadingMessage={() => "در حال جستجو..."}
      />
    </div>
  );
});

export default UsersSelect;
